// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Date$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as UnorderedList from "../../../../../../../../library/components/unordered-list/UnorderedList.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function getColumnSchema(workspaceDispatch) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Case no."
            },
            accessor: (function (ticket) {
                return {
                        TAG: /* ActionButton */3,
                        _0: ticket.case_number,
                        _1: (function (param) {
                            return Curry._2(workspaceDispatch.addTab, {
                                        TAG: /* Ticket */43,
                                        case_number: ticket.case_number
                                      }, false);
                          })
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Timestamp"
              },
              accessor: (function (ticket) {
                  return {
                          TAG: /* Date */1,
                          format: "DD/MM/YY | h:mm a",
                          date: Date$Catalyst.fromJsDate(new Date(Timestamp$Catalyst.toFloat(ticket.raised_at)))
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Issues"
                },
                accessor: (function (ticket) {
                    return {
                            TAG: /* Custom */5,
                            _0: (function (param) {
                                if (List.length(ticket.issues) === 1) {
                                  return List.hd(ticket.issues);
                                } else {
                                  return React.createElement(UnorderedList.make, {
                                              list: ticket.issues
                                            });
                                }
                              })
                          };
                  })
              },
              tl: /* [] */0
            }
          }
        };
}

export {
  getColumnSchema ,
  
}
/* react Not a pure module */
